import React from 'react';
import Grid from 'components/Custom/Grid';
import Visitor from 'classes/Visitor';
import { getVisitors } from 'utils/VisitorUtils';
import { useAppContext } from 'hooks/useAppContext';

export default function VisitorGrid() {
  const columns = Visitor.columns;
  const { selectedProject } = useAppContext();

  return (
    <Grid
      columns={columns}
      title="Visitor"
      getRecords={getVisitors}
      selectedProject={selectedProject}
      component="Inspections"
      enable={{ update: false, delete: false }}
      inspectionColumnTitle="Inspection #"
      options={{ pageSizeOptions: [10, 15, 25], pageSize: 10 }}
    />
  );
}
